module.exports = __webpack_public_path__ + "img/help_authentication_hfp@3x.4d66dfb9.png";